/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyPasswordResetCodeRequest
 */
export interface VerifyPasswordResetCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof VerifyPasswordResetCodeRequest
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof VerifyPasswordResetCodeRequest
     */
    oobCode: string;
}

/**
 * Check if a given object implements the VerifyPasswordResetCodeRequest interface.
 */
// @ts-ignore
export function instanceOfVerifyPasswordResetCodeRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "oobCode" in value;

    return isInstance;
}

// @ts-ignore
export function VerifyPasswordResetCodeRequestFromJSON(json: any): VerifyPasswordResetCodeRequest {
    return VerifyPasswordResetCodeRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function VerifyPasswordResetCodeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyPasswordResetCodeRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'username': json['username'],
        'oobCode': json['oob_code'],
    };
}

// @ts-ignore
export function VerifyPasswordResetCodeRequestToJSON(value?: VerifyPasswordResetCodeRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'username': value.username,
        'oob_code': value.oobCode,
    };
}

